var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "afilliaton-summary" },
    [
      _c("v-layout", { attrs: { row: "", "justify-center": "" } }, [
        _c("h2", { staticClass: "stepper__title gray" }, [
          _vm._v(" Resumen de afiliación")
        ])
      ]),
      _c("v-layout", { staticClass: "mt-3", attrs: { "justify-center": "" } }, [
        _c(
          "div",
          { staticClass: "afilliaton-summary__content" },
          [
            _c("h3", { staticClass: "stepper__subtitle" }, [
              _vm._v(" Tipo de solución")
            ]),
            _c("p", { staticClass: "mb-1" }, [_vm._v(_vm._s(_vm.posName))]),
            _vm.affiliation !== "No aplica" ||
            _vm.affiliationComment !== "No aplica" ||
            _vm.equipmentCost !== "No aplica" ||
            _vm.equipmentCostComment !== "No aplica"
              ? _c(
                  "div",
                  [
                    _c("h3", { staticClass: "stepper__subtitle" }, [
                      _vm._v("Cargo por única vez")
                    ]),
                    _vm.affiliation !== "No aplica"
                      ? _c(
                          "v-layout",
                          { staticClass: "mb-2" },
                          [
                            _c("v-flex", [_vm._v("Afiliación")]),
                            _c("v-flex", { staticClass: "text-xs-right" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.affiliation))])
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.affiliationComment !== "No aplica"
                      ? _c("div", [
                          _vm.affiliationComment
                            ? _c("h3", { staticClass: "stepper__subtitle" }, [
                                _vm._v(_vm._s(_vm.affiliationComment))
                              ])
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm.equipmentCost !== "No aplica"
                      ? _c(
                          "v-layout",
                          { staticClass: "mb-2" },
                          [
                            _c("v-flex", [_vm._v("Costo por equipo")]),
                            _c("v-flex", { staticClass: "text-xs-right" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.equipmentCost))])
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.equipmentCostComment !== "No aplica"
                      ? _c("div", [
                          _vm.equipmentCostComment
                            ? _c("h3", { staticClass: "stepper__subtitle" }, [
                                _vm._v(_vm._s(_vm.equipmentCostComment))
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.maintenance !== "No aplica" ||
            _vm.maintenanceComment !== "No aplica"
              ? _c(
                  "div",
                  [
                    _c("h3", { staticClass: "stepper__subtitle mt-3 mb-1" }, [
                      _vm._v("Cargo mensual                ")
                    ]),
                    _vm.maintenance !== "No aplica"
                      ? _c(
                          "v-layout",
                          { staticClass: "mb-1" },
                          [
                            _c("v-flex", [_vm._v("Mantenimiento")]),
                            _c("v-flex", { staticClass: "text-xs-right" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.maintenance))])
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.maintenanceComment !== "No aplica"
                      ? _c("div", [
                          _vm.maintenanceComment
                            ? _c("h3", { staticClass: "stepper__subtitle" }, [
                                _vm._v(_vm._s(_vm.maintenanceComment) + " ")
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.renewal !== "No aplica" || _vm.renewalComment !== "No aplica"
              ? [
                  _c("h3", { staticClass: "stepper__subtitle mt-3 mb-1" }, [
                    _vm._v("Cargo anual")
                  ]),
                  _vm.renewal !== "No aplica"
                    ? _c(
                        "v-layout",
                        { staticClass: "mb-1" },
                        [
                          _c("v-flex", [_vm._v("Renovación")]),
                          _c("v-flex", { staticClass: "text-xs-right" }, [
                            _c("strong", [_vm._v(_vm._s(_vm.renewal))])
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.renewalComment !== "No aplica"
                    ? _c("div", [
                        _vm.renewalComment
                          ? _c("h3", { staticClass: "stepper__subtitle" }, [
                              _vm._v(_vm._s(_vm.renewalComment))
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]
              : _vm._e(),
            _c("v-divider", { staticClass: "divider-line" }),
            _c("h3", { staticClass: "stepper__subtitle mt-3 mb-1" }, [
              _vm._v("Cargos por cada venta")
            ]),
            _vm.platformUsageCE !== "No aplica" ||
            _vm.platformUsageCEComment !== "No aplica"
              ? _c(
                  "div",
                  [
                    _vm.platformUsageCE !== "No aplica"
                      ? _c(
                          "v-layout",
                          [
                            _c("v-flex", [_vm._v("Uso de plataforma web   ")]),
                            _c("v-flex", { staticClass: "text-xs-right" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.platformUsageCE))
                              ])
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.platformUsageCEComment !== "No aplica"
                      ? _c("div", [
                          _vm.platformUsageCEComment
                            ? _c("h3", { staticClass: "stepper__subtitle" }, [
                                _vm._v(_vm._s(_vm.platformUsageCEComment))
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "v-layout",
              [
                _c(
                  "a",
                  {
                    staticClass: "stepper__prev",
                    on: {
                      click: function($event) {
                        _vm.dialog = true
                      }
                    }
                  },
                  [_vm._v("Ver comisiones")]
                ),
                _c(
                  "v-dialog",
                  {
                    attrs: { width: "600px" },
                    model: {
                      value: _vm.dialog,
                      callback: function($$v) {
                        _vm.dialog = $$v
                      },
                      expression: "dialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      { staticStyle: { "padding-bottom": "30px" } },
                      [
                        _c(
                          "v-card-actions",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-end"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                on: { click: _vm.tableComissionClose }
                              },
                              [_c("v-icon", [_vm._v("close")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-layout", [_c("comisions")], 1)
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("span", { staticClass: "pt-3 d-block" }, [
              _vm.multiAdress.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", [
                            _vm._v("Cantidad de códigos Afiliados   ")
                          ]),
                          _c("v-flex", { staticClass: "text-xs-right" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.multiAdress.length) + "             "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("h3", { staticClass: "stepper__subtitle mt-3" }, [
              _vm._v("Ciclo de facturación")
            ]),
            _c("p", [_vm._v("Del 26 al 25 del mes siguiente")]),
            _c("personal-data-treatment-radio", {
              model: {
                value: _vm.authorizePersonalDataTreatment,
                callback: function($$v) {
                  _vm.authorizePersonalDataTreatment = $$v
                },
                expression: "authorizePersonalDataTreatment"
              }
            })
          ],
          2
        )
      ]),
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c(
            "v-btn",
            {
              staticClass: "primary-button",
              attrs: { disabled: _vm.$v.$invalid },
              on: { click: _vm.onSubmit }
            },
            [_vm._v("Continuar")]
          ),
          _c(
            "v-btn",
            {
              staticClass: "primary-button text black capitalize",
              attrs: { small: "" },
              on: {
                click: function($event) {
                  _vm.changeStep(false)
                }
              }
            },
            [_vm._v("Atrás")]
          )
        ],
        1
      ),
      _c("loader", { ref: "loaderModal", attrs: { text: _vm.messageModal } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28387a09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28387a09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/afilliation-summary-virtual.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-28387a09","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stepper/afilliation-summary-virtual.vue
// module chunks = 0 1 2 3